export default __webpack_public_path__ + "static/media/TrendFlat.4089e454.svg";